import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between my-4 gap-3">
      <div className="text-gray-700 text-center sm:text-left order-2 sm:order-1 mb-3 sm:mb-0 w-full sm:w-auto">
        Page {currentPage + 1} of {totalPages || 1}
      </div>
      
      <div className="flex justify-between w-full sm:w-auto gap-2 order-1 sm:order-2">
        <button
          onClick={handlePrevious}
          disabled={currentPage === 0}
          className={`px-4 py-3 rounded-md min-h-[44px] flex-1 sm:flex-none ${
            currentPage === 0
              ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
              : 'bg-blue-500 text-white hover:bg-blue-600'
          }`}
          aria-label="Previous page"
        >
          Previous
        </button>
        
        <button
          onClick={handleNext}
          disabled={currentPage >= totalPages - 1}
          className={`px-4 py-3 rounded-md min-h-[44px] flex-1 sm:flex-none ${
            currentPage >= totalPages - 1
              ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
              : 'bg-blue-500 text-white hover:bg-blue-600'
          }`}
          aria-label="Next page"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination; 